import './BetbookPostTicket.less';

import React, { useContext } from 'react';
import { getWinText } from '@/mytickets/detail/views/TicketHeader';
import BetbookTicket from 'nike-ui/src/components/betbook/betbookTicket/BetbookTicket';
import PopupNg from '@/ui/PopupNg';
import BetbookContext from 'nike-ui/src/common/BetbookContext';

function openTicketDetail(e, isAnalysis, hash, betbookContext) {
    if (isAnalysis) {
        e.stopPropagation();
        e.preventDefault();
        PopupNg.dispatcher.open('betbook/ticketDetailPopup', { hash, isAnalysis, betbookContext }, 2);
    }
}

function BetbookPostTicket({ ticket, editorTicket = undefined, isAnalysis, hash, label }) {
    const betbookContext = useContext(BetbookContext);
    const winText = getWinText(ticket.status, ticket.winningMethod);
    return (
        <div
            className="pointer"
            onClick={e => openTicketDetail(e, isAnalysis, hash, betbookContext)}
            data-atid="betbook-analyse-mobile-ticket"
        >
            <BetbookTicket
                mobile
                label={label}
                ticket={ticket}
                otherClassName="py-15"
                betbookWinLabel={winText}
                showBetStatusCounts={!editorTicket}
                isTicketPost={editorTicket}
            />
        </div>
    );
}

export default BetbookPostTicket;
